(function() {
  'use strict';
  
  // 只处理手动加粗的数字（strong、b标签内的数字），支持p、ul、li标签
  function processManualBoldNumbers() {
    const richTextElements = document.querySelectorAll('.t4s-rich-text .t4s-rich-text-process-number');
    
    richTextElements.forEach(function(element) {
      // 在p、ul、li标签内查找 strong 和 b 标签内的数字
      const containers = element.querySelectorAll('p, ul, li');
      
      containers.forEach(function(container) {
        const boldElements = container.querySelectorAll('strong, b, [style*="font-weight: bold"], [style*="font-weight:900"], [style*="font-weight: 900"]');
        
        boldElements.forEach(function(boldEl) {
          // 如果元素内只有数字，添加 t4s-rich-text-number 类以应用样式
          const text = boldEl.textContent.trim();
          if (/^\d+(?:\.\d+)?%?$/.test(text)) {
            boldEl.classList.add('t4s-rich-text-number');
          } else {
            // 如果元素内包含数字和其他文本，只对数字部分进行处理
            const walker = document.createTreeWalker(
              boldEl,
              NodeFilter.SHOW_TEXT,
              null
            );
            
            const textNodes = [];
            let textNode;
            while (textNode = walker.nextNode()) {
              textNodes.push(textNode);
            }
            
            textNodes.forEach(function(textNode) {
              const text = textNode.textContent;
              const numberRegex = /(\d+(?:\.\d+)?%?)/g;
              const matches = [];
              let match;
              
              while ((match = numberRegex.exec(text)) !== null) {
                matches.push({
                  text: match[0],
                  index: match.index,
                  length: match[0].length
                });
              }
              
              if (matches.length === 0) return;
              
              const fragment = document.createDocumentFragment();
              let lastIndex = 0;
              
              matches.forEach(function(match) {
                if (match.index > lastIndex) {
                  fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
                }
                
                const span = document.createElement('span');
                span.className = 't4s-rich-text-number';
                span.textContent = match.text;
                fragment.appendChild(span);
                
                lastIndex = match.index + match.length;
              });
              
              if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
              }
              
              textNode.parentNode.replaceChild(fragment, textNode);
            });
          }
        });
      });
    });
  }
  
  // Show More 功能
  function initShowMore() {
    const showMoreWrappers = document.querySelectorAll('.t4s-rich-text .t4s-show-more-wrapper');
    
    showMoreWrappers.forEach(function(showMoreWrapper) {
      const btn = showMoreWrapper.querySelector('.t4s-show-more-btn');
      const labelEl = btn ? btn.querySelector('.t4s-show-more-text') : null;
      const collapsedLabel = labelEl ? labelEl.textContent.trim() : 'SHOW MORE';
      const expandedLabel = 'HIDE';
      const contentWrapper = showMoreWrapper.previousElementSibling;
      const collapseHeight = showMoreWrapper.getAttribute('data-collapse-height') || '200';
      
      if (!btn || !contentWrapper) return;

      function syncButtonLabel() {
        if (!labelEl) return;
        const isExpanded = showMoreWrapper.classList.contains('t4s-expanded');
        const nextLabel = isExpanded ? expandedLabel : collapsedLabel;
        labelEl.textContent = nextLabel;
        btn.setAttribute('aria-label', nextLabel);
      }
      
      // 设置初始高度
      contentWrapper.style.setProperty('--collapse-height', collapseHeight + 'px');
      syncButtonLabel();
      
      // 检查内容是否超出高度
      function checkContentHeight() {
        if (window.innerWidth > 767) return;
        const contentHeight = contentWrapper.scrollHeight;
        const maxHeight = parseInt(collapseHeight);
        
        if (contentHeight <= maxHeight) {
          showMoreWrapper.style.display = 'none';
        } else {
          showMoreWrapper.style.display = 'flex';
        }
      }
      
      // 初始检查
      checkContentHeight();
      window.addEventListener('resize', checkContentHeight);
      
      // 点击事件 - 使用捕获阶段确保事件能够触发
      let lastToggleAt = 0;
      function handleShowMoreClick(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const now = Date.now();
        // 同时监听 mousedown + click 时，避免一次操作触发两次切换
        if (now - lastToggleAt < 200) return false;
        lastToggleAt = now;
        contentWrapper.classList.toggle('t4s-expanded');
        showMoreWrapper.classList.toggle('t4s-expanded');
        syncButtonLabel();
        return false;
      }
      
      // 使用捕获阶段监听，确保在父元素阻止之前捕获事件
      btn.addEventListener('click', handleShowMoreClick, true);
      btn.addEventListener('mousedown', handleShowMoreClick, true);
      
      // 确保按钮可点击
      btn.style.pointerEvents = 'auto';
      btn.style.cursor = 'pointer';
      btn.setAttribute('tabindex', '0');
      
      // 添加键盘支持
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleShowMoreClick(e);
        }
      });
    });
  }
  
  // 执行初始化函数
  function init() {
    processManualBoldNumbers();
    initShowMore();
  }
  
  // 监听DOM变化，处理动态加载的内容
  function setupObserver() {
    if (typeof MutationObserver === 'undefined') return;
    
    if (!document.body) {
      // 如果body还不存在，等待DOMContentLoaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupObserver);
      } else {
        setTimeout(setupObserver, 100);
      }
      return;
    }
    
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('t4s-rich-text') ||
                (node.querySelector && node.querySelector('.t4s-rich-text'))
              )) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      if (shouldReinit) {
        setTimeout(init, 50);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // 使用多种方式确保执行
  function runInit() {
    // 如果DOM已经加载完成，立即执行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init();
        setupObserver();
      });
    } else {
      init();
      setupObserver();
    }
  }
  
  // 页面加载完成后执行
  runInit();
  
  // 确保在window.load时也执行一次
  window.addEventListener('load', function() {
    setTimeout(init, 100);
  });
})();

